import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule, AutoCompleteCompleteEvent, AutoCompleteLazyLoadEvent, 
  AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { ScrollerOptions } from 'primeng/api';

import { MfgappsApiService } from 'src/app/services/mfgapps-api.service';
import { MfgappsEventService } from 'src/app/services/mfgapps-event.service';

@Component({
  selector: 'app-user-autocomplete',
  imports: [FormsModule, AutoCompleteModule],
  templateUrl: './user-autocomplete.component.html',
  styleUrl: './user-autocomplete.component.scss'
})
export class UserAutocompleteComponent {
  @Input() entry: any = {};
  @Input() fieldToSave = 'email_id';
  @Input() inputDisabled = false;
  @Input() showDropdown = true;
  @Output() userSelected = new EventEmitter<{ entry: any, selectedUser: any }>();
  readonly minimumInputLengthForSearch = 3;
  readonly autoCompletePlaceHolder = `Type minimum ${this.minimumInputLengthForSearch} characters to search`;
  readonly topNUsers = 20; //Number of users to load in autocomplete dropdown with virtual scroll
  //Setup Scroller options for autocomplete dropdown with callback to load more users on scroll
  readonly autoCompleteScrollerOptions: ScrollerOptions = {
    step: this.topNUsers, itemSize: 32, onScrollIndexChange: this.usersListScrolled.bind(this)
  };
  suggestedUsers: any[] = [];
  usersListResponse!: { value: any[], '@odata.nextLink'?: string };
  userSearchTerm = '';

  constructor(private readonly mfgappsApiService: MfgappsApiService, private readonly eventService: MfgappsEventService) {}

  async filterUsers(event: AutoCompleteCompleteEvent) {
    //If search term is same as previous search and users are already loaded, do not make API call again
    if (event.query === this.userSearchTerm) {
      this.suggestedUsers = this.suggestedUsers.slice();
    }
    else if (event.query.length >= this.minimumInputLengthForSearch) {
      this.userSearchTerm = event.query;
      this.usersListResponse = await this.mfgappsApiService.fetchToyotaUserDetails(this.userSearchTerm);
      this.suggestedUsers = this.usersListResponse.value;
    }
  }
  
  async usersListScrolled(event: AutoCompleteLazyLoadEvent) {
    //If nextLink is available and user has scrolled to the end of currently loaded users, load more users
    if (this.usersListResponse['@odata.nextLink'] && !this.autoCompleteScrollerOptions.loading 
      && (event.first >= (this.suggestedUsers.length - (this.topNUsers / 2))) && event.last >= this.suggestedUsers.length) {
      this.autoCompleteScrollerOptions.loading = true;
      this.usersListResponse = await this.mfgappsApiService.fetchToyotaUserDetails(this.userSearchTerm, this.usersListResponse['@odata.nextLink']);
      this.suggestedUsers = this.suggestedUsers.concat(this.usersListResponse.value);
      this.autoCompleteScrollerOptions.loading = false;
    }
  }

  onUserSelect(event: AutoCompleteSelectEvent) {
    this.userSelected.emit({ entry: this.entry, selectedUser: event.value });
  }
}